<template>

</template>

<script>
	export default {
		props: ['href'],
		computed: {
            isAuthorized() {
				let token = document.head.querySelector('meta[name="google-access-token"]');
				return token.content.length ? true : false;
            }
		},
		methods: {
			onSubmit() {
				location.href = this.href
			}
		}
	}
</script>